import type { FC, ReactNode } from 'react'

import { cn } from '@/lib/utils'
import { Label } from '@/components/ui/label'

interface FormFieldProps {
    id: string
    label: string
    hint?: ReactNode
    error?: string
    optional?: boolean
    children: ReactNode
    className?: string
}

export const describedBy = (id: string, error?: string, hint?: ReactNode): string | undefined => {
    if (error) return `${id}-error`
    if (hint) return `${id}-hint`

    return undefined
}

const FormField: FC<FormFieldProps> = ({
    id,
    label,
    hint,
    error,
    optional = false,
    children,
    className
}): ReactNode => {
    return (
        <div className={cn('flex min-w-0 flex-col gap-1.5', className)}>
            <Label htmlFor={id} className='text-[0.8rem] font-medium'>
                {label}

                {optional && (
                    <span className='font-normal text-muted-foreground'>
                        (opcional)
                    </span>
                )}
            </Label>

            {children}

            {error && (
                <p id={`${id}-error`} className='text-xs text-destructive'>
                    {error}
                </p>
            )}

            {!error && hint && (
                <p id={`${id}-hint`} className='text-xs text-muted-foreground'>
                    {hint}
                </p>
            )}
        </div>
    )
}

export default FormField
